import { Component, OnInit } from '@angular/core';
import { GenericAPIService } from 'src/app/services/generic-api.service';
import { Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { UrlConstants } from 'src/app/constants/url-constants';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit {
  public playerLadderUrl = UrlConstants.playerList;
  public users = [];
  public isUserList = false;
  public userResultList=[];
  PreLoader = false;
  noPlayer=false;
  userId;
  constructor(public _genericService: GenericAPIService,public router: Router,public encryptDecryptService:EncryptDecryptService) {
    this.userId = this.encryptDecryptService.getLocalStorage("userId");
    this.getPlayerLeaderBoardList();
  }
  ngOnInit() {
  }
  getPlayerLeaderBoardList() {
    this.PreLoader = true;
    var raceId = +this.encryptDecryptService.getLocalStorage("previousRaceId");
    this._genericService.getAll(this.playerLadderUrl + "?raceId=" + raceId).subscribe(response => {
      if (response.status.success == "Success") {
        this.isUserList = response.data.isUserList;
        if (this.isUserList == true) {
          this.users = response.data.responseList;
        }
        else{
          this.userResultList = response.data.responseList;
        }
        this.PreLoader = false;
      }
      else{
        this.noPlayer=true;
        this.PreLoader = false;
      }

    },error=>{
      this.PreLoader = false;
      this.noPlayer=true;
    })
  }
}
